module.exports = __webpack_public_path__ + "img/voucher-icon_grey.cc24119e.svg";